import {PERSONALISATION_SESSION_STORAGE_KEY} from "../../config/constants"

const cleanupPersonalisationData = (personalisationDataAge: number, callback: () => void) => {
    try {
        const sessionStorageKeys = Object.keys(sessionStorage)
        const personalisationKeys = sessionStorageKeys.filter(key =>
            key.startsWith(`${PERSONALISATION_SESSION_STORAGE_KEY}_`),
        )

        if (personalisationKeys.length === 0) {
            callback()
            return
        }

        let latestTimestamp = 0
        let latestKey = ""

        // Find the latest timestamp among all personalisation keys
        personalisationKeys.forEach(key => {
            const value = sessionStorage.getItem(key)
            if (value) {
                const timestamp = parseInt(value, 10)
                if (!Number.isNaN(timestamp) && timestamp > latestTimestamp) {
                    latestTimestamp = timestamp
                    latestKey = key
                }
            }
        })
        // Check if the latest timestamp is older than personalisationDataAge minutes
        const dataExpiryThreshold = Date.now() - personalisationDataAge * 60 * 1000

        if (latestTimestamp > 0 && latestTimestamp < dataExpiryThreshold) {
            personalisationKeys.forEach(key => {
                sessionStorage.removeItem(key)
            })
            sessionStorage.removeItem(PERSONALISATION_SESSION_STORAGE_KEY)
        }
        callback()
    } catch (error) {
        console.warn("Failed to cleanup personalisation data from session storage:", error)
        callback()
    }
}

export default cleanupPersonalisationData
